import { render, staticRenderFns } from "./downloadxia.vue?vue&type=template&id=125cc7c5"
import script from "./downloadxia.vue?vue&type=script&lang=js"
export * from "./downloadxia.vue?vue&type=script&lang=js"
import style0 from "./downloadxia.vue?vue&type=style&index=0&id=125cc7c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports